// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSession from 'vue-session'
import Toasted from 'vue-toasted'
import VueAnalytics from 'vue-analytics'

Vue.use(Toasted)

Vue.use(VueAnalytics, {
  id: 'UA-151457223-1',
  router
})

Vue.filter('Number', function (value) {
  if (!value) return ''
  return (value.toString().match(/.{1,3}/g)).join('-')
})

Vue.use(VueSession, {
  persist: true
})

Vue.use(VueAxios, axios)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js